import React from 'react';
import icInvoice from './icons/ic-invoice.svg'
import secondaryshape from './icons/secondary-shape.svg'


export default function PaidOnlineCard({ services }) {

    const renderPayAtShopIcon = (services = []) => {
        if (!Array.isArray(services) || services.length === 0) return null;

        // Helper: Normalize name
        const normalizeName = (name) => name?.replace(/\s+/g, ' ').trim();
        // Helper: Group all paid statuses (Handles your specific dataset)
        const isPaid = (status) => status === 'PaidInstall' || status === 'PaidServices';

        if (services.length === 1) {
            const service = services[0];
            const name = normalizeName(service?.display_name);
            const status = service?.service_payment_status;

            if (name === "New Tire Installation") {
                // Use Case 1: Prepaid
                if (isPaid(status)) {
                    return icInvoice;
                }
                // Use Case 2: Pay at Shop
                if (status === 'PayAtShop') {
                    return secondaryshape;
                }
            }

            // Use Case 3: Tire Pick Up (or other single services)
            return secondaryshape;
        }
        else {
            const statuses = services.map(s => s?.service_payment_status);

            // Check if everything is Pay at Shop (UC 5, 6, 7)
            const allArePayAtShop = statuses.every(s => s === 'PayAtShop');
            if (allArePayAtShop) {
                return secondaryshape;
            }

            // Check if everything is Paid (Matches your 5-item dataset)
            const allArePaid = statuses.every(s => isPaid(s));
            if (allArePaid) {
                return icInvoice;
            }

            // Use Case 4: Mixed (Prepaid Tire + Shop Items)
            // If the main Tire Installation is paid, we usually show the Invoice icon
            const hasPaidTire = services.some(s =>
                normalizeName(s.display_name) === "New Tire Installation" &&
                s.service_payment_status === "PaidInstall"
            );

            if (hasPaidTire) {
                return icInvoice;
            }
        }

        // Default Fallback
        return secondaryshape;
    };
    const renderPayAtShop = (services = []) => {
        if (!Array.isArray(services) || services.length === 0) return null;

        // Helper: Normalize name
        const normalizeName = (name) => name?.replace(/\s+/g, ' ').trim();
        // Helper: Identify any "Paid" status (Handles your specific dataset)
        const isPaid = (status) => status === 'PaidInstall' || status === 'PaidServices';

        if (services.length === 1) {
            const service = services[0];
            const name = normalizeName(service?.display_name);
            const status = service?.service_payment_status;

            if (name === "New Tire Installation") {
                // Use Case 1: Paid online
                if (isPaid(status)) {
                    return "Paid Online";
                }
                // Use Case 2: Pay at shop
                if (status === 'PayAtShop') {
                    return "Payment not prepaid";
                }
            }

            // Use Case 3: Tire Pick Up or any other single service
            return "Payment not prepaid";
        }
        else {
            const statuses = services.map(s => s?.service_payment_status);

            // Check if everything is Pay at Shop (UC 5, 6, 7)
            const allArePayAtShop = statuses.every(s => s === 'PayAtShop');
            if (allArePayAtShop) {
                return "Payment not prepaid";
            }

            // Check if everything is Paid (This catches your 5-item dataset)
            const allArePaid = statuses.every(s => isPaid(s));
            if (allArePaid) {
                return "Paid Online";
            }

            // Use Case 4: Mixed (Prepaid Tire + Shop Items)
            // Requirement says if tires are paid online, the type is "Paid Online"
            const hasPaidTire = services.some(s =>
                normalizeName(s.display_name) === "New Tire Installation" &&
                s.service_payment_status === "PaidInstall"
            );

            if (hasPaidTire) {
                return "Paid Online";
            }
        }

        // Default fallback (UC 5/6)
        return "Payment not prepaid";
    };

    const renderSubTitle = (services = []) => {
        if (!Array.isArray(services) || services.length === 0) return null;
        // Helper: Normalize name for comparison
        const normalizeName = (name) => name?.replace(/\s+/g, ' ').trim();
        // Helper: Treat both 'PaidInstall' and 'PaidServices' as "Paid Online"
        const isPaid = (status) => status === 'PaidInstall' || status === 'PaidServices';

        if (services.length === 1) {
            const service = services[0];
            const name = normalizeName(service?.display_name);
            const status = service?.service_payment_status;

            if (name === "New Tire Installation") {
                if (status === 'PaidInstall') {
                    return "Customer has pre-paid for installation";
                }
                if (status === 'PayAtShop') {
                    return "Customer will pay at the Shop";
                }
            }

            // Handles "Tire Pick Up" and other single services (UC 3)
            return "Consult with the customer in the store";
        }
        else {
            const statuses = services.map(s => s?.service_payment_status);

            // Check if everything is Pay at Shop (UC 2, 5, 7)
            const allArePayAtShop = statuses.every(s => s === 'PayAtShop');
            if (allArePayAtShop) {
                return "Consult with the customer in-store";
            }

            // Check if everything is paid (Matches your 5-item data set: 1 PaidInstall + 4 PaidServices)
            const allArePaid = statuses.every(s => isPaid(s));
            if (allArePaid) {
                return "Customer has pre-paid for services";
            }

            // Check for Mixed Case (UC 4): Paid Tire Installation + some Pay at Shop items
            const hasPaidTire = services.some(s =>
                normalizeName(s.display_name) === "New Tire Installation" &&
                s.service_payment_status === "PaidInstall"
            );
            const hasPayAtShop = statuses.includes("PayAtShop");

            if (hasPaidTire && hasPayAtShop) {
                return "Customer has pre-paid for installation";
            }
        }

        // Use Case 5 & 6 Fallback: If no other conditions are met
        return "Consult with the customer in-store";
    };
    return (
        <div style={styles.wrapper}>
            <img
                src={renderPayAtShopIcon(services)}
                style={{ height: 48, width: 48 }}
            />
            <div>
                <div style={styles.title}>{renderPayAtShop(services)}</div>
                <div style={styles.subtitle}>{renderSubTitle(services)}</div>
            </div>
        </div>
    );


}

const styles = {
    wrapper: {
        display: 'flex',
        gap: '12px',
        alignItems: 'center',
        fontFamily: 'Arial, sans-serif',
    },
    iconBox: {
        width: '32px',
        height: '36px',
        backgroundColor: '#E0ECF5',      // light blue
        color: '#2A6B8F',                // icon blue
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '6px',
        fontSize: '16px',
        fontWeight: 600,
    },
    title: {
        fontWeight: '600',
        color: '#212B36',
        fontSize: '14px',
        marginBottom: '2px',
    },
    subtitle: {
        fontSize: '13px',
        color: '#637381',
    },
};
